<template>
  <div style="height: 100vh;">
    <iframe
      :src="file_source"
      width="100%"
      height="100%"
      frameborder="0"
    />
  </div>
</template>

<script>
export default {
    data() {
        return {
            file_source: "",
        }
    },
    created() {
        const fileURL = `${window.location.origin}/docs/data-privacy-policy.docx`
        this.file_source = `https://docs.google.com/gview?url=${encodeURIComponent(fileURL)}&embedded=true`
    },
}
</script>
